


















































import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import {CashoutData} from "../models";
import {cashoutEventBus, CashoutEvents, CheckoutErrorMode, CheckoutErrorModes} from "../bus";
import {doOrder} from "../order";

// From https://stackoverflow.com/a/42782228
Vue.directive('focus', {
    inserted: function (el) {
        el.focus();
    },
    update: function (el) {
        Vue.nextTick(function () {
            el.focus();
        })
    }
});

@Component
export default class CashoutModal2FA extends Vue {
    @Prop()
    cashoutData!: CashoutData;

    verifying: boolean = false;
    fakeStep: boolean = false;

    failed: boolean = false;

    mounted(): void {
        cashoutEventBus.$on(CashoutEvents.CHECKOUT_ERROR, this.checkoutError);
        cashoutEventBus.$on(CashoutEvents.CHECKOUT_FAILURE, this.modalClose);
    }

    modalOpen() {
        this.verifying = false;
        this.$modal.show('2fa-modal');
    }

    modalClose() {
        this.$modal.hide('2fa-modal');
    }

    checkoutError(errorMode: CheckoutErrorMode, message: string) {
        // Handled by 2FA modal
        if (errorMode === CheckoutErrorModes.AUTH_2FA_REQUIRED) {
            this.verifying = false;
            this.failed = false;
            this.modalOpen()
        } else if (errorMode === CheckoutErrorModes.AUTH_2FA_INVALID) {
            this.verifying = false;
            this.failed = true;
            this.modalOpen()
        } else {
            this.modalClose()
        }
    }

    verify() {
        this.verifying = true;
        this.failed = false;
        this.fakeStep = false;
        setTimeout(() => {
            if (this.verifying) this.fakeStep = true;
        }, 1600);
        //
        cashoutEventBus.$emit(CashoutEvents.CHECKOUT_START);
        doOrder(this.cashoutData)
    }

    modalOpened() {
    }

    modalClosed() {
        // Reset modal
        this.cashoutData.twoFactorCode = '';
        this.verifying = false;
        this.failed = false;
    }
}
